import { INITIALIZE_USER, LOGOUT } from 'src/reducers/user/types';

import { urls } from 'Utilities/dataHelpers';
import * as log from 'Utilities/log';
import mediator from 'Utilities/mediator';
import { isObjectEmpty } from 'Utilities/newyu';
import {
  clearCookie,
  removeSessionObject,
  setCookie,
  setSessionObject,
  updateChosenCountryLang,
} from 'Utilities/storage';
import { store } from 'Utilities/store';

const _finishLoginSuccess = () => {
  const {
    nav: { redirection },
    user: {
      system: { messages: sysMessages = {} },
    },
  } = store.getState();

  const current = false;
  const invitationList: any[] = [];

  if (redirection) {
    mediator.publish('router:navigate', redirection);
  } else if (
    // Only display the welcome screen for new accounts registered via the webApp
    sysMessages !== null &&
    sysMessages.webRegister !== undefined &&
    sysMessages.welcomeScreen === undefined
  ) {
    mediator.publish('user:dismissSystemMessage', { messageId: 'welcomeScreen' });
    // mediator.publish('router:navigate', '/welcome');
  } else {
    if ((current && !isObjectEmpty(current)) || invitationList.length) {
      mediator.once('page:meter', () => {
        if (current && !isObjectEmpty(current)) {
          // if the invitation is already loaded up
          mediator.publish('invitations:emailInviteModal');
        } else {
          // if not, load it up
          mediator
            .request('invitations:getInvitation', { invitationId: invitationList[0] })
            .then(() => {
              mediator.publish('invitations:emailInviteModal');
            });
        }
      });
    }

    mediator.publish('router:navigate', '/');
  }
};

const handleLoginSuccess = (request: any) => {
  const {
    user: { country: currentCountry },
  } = store.getState();

  setSessionObject('loggedIn', { loggedIn: true });
  setCookie('loggedIn', true, 7200000);

  // the logic around this flag is to make sure that we have an updated config before trying to log in
  const updateConfig = currentCountry !== request.user.country;

  if (updateConfig) {
    mediator.once('config:UpdatedConfigForCountry', () => {
      updateChosenCountryLang(request.user.country, request.user.uiLanguage);
      _finishLoginSuccess();
    });
  }

  store.dispatch({ type: INITIALIZE_USER, ...request });
  mediator.publish('analytics:setUserId', request.user.id);

  if (!updateConfig) {
    updateChosenCountryLang(request.user.country, request.user.uiLanguage);
    _finishLoginSuccess();
  }
};

const handleLoggedOut = () => {
  removeSessionObject('loggedIn');
  clearCookie('loggedIn');
  store.dispatch({ type: LOGOUT });
  mediator.publish('router:navigate', '/');
};

const handleGetAccount = (request: any) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request<{ user: User }>('api:invoke', {
        method: 'GET',
        url: urls.lslApi + 'account',
      })
      .then((result) => {
        if (result.status === 0) {
          // store.dispatch({ type: UPDATE_PROFILE, data: result.data.user });
          resolve(result.data.user);
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        log.error(err);
        reject(err);
      });
  });
};

// Load our user from session storage and route correctly to our API based on if we
// are using a temp token converted from the legacy webviews or a stored new token
const handleGetUser = (request: any) => {
  const {
    auth: { legacyToken },
  } = store.getState();

  request.response = new Promise((resolve, reject) => {
    mediator
      .request<{ user: User; redirect: boolean; region: string }>('api:invoke', {
        method: 'GET',
        url: urls.lslApi + (legacyToken ? `sharing/token/${legacyToken}` : 'user'),
      })
      .then((result) => {
        if (result.status === 0) {
          updateChosenCountryLang(result.data.user.country, result.data.user.uiLanguage);

          store.dispatch({ type: INITIALIZE_USER, ...result.data });
          mediator.publish('analytics:setUserId', result.data.user.id);

          resolve(result.data);
        } else {
          log.error(result.error);
          reject(result);
        }
      })
      .catch((err) => {
        log.error(err);
        reject(err);
      });
  });
};

const handleGetAccountSettings = (request: any) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request('api:invoke', {
        method: 'POST',
        url: urls.lslApi + 'user/getAccountSettings',
      })
      .then((result) => {
        // store.dispatch({ type: GET_ACCOUNT_SETTINGS, settings: result.data });

        if (result.status === 0) {
          resolve(result);
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        log.error(err);
        reject(err);
      });
  });
};

const handleUserLookup = (request: any) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request('api:invoke', {
        method: 'GET',
        url: urls.lslApi + 'user/userLookup',
        data: {
          email: request.email,
        },
      })
      .then((result) => {
        if (result.status === 0) {
          resolve(result);
        } else {
          reject(result);
        }
      });
  });
};

// we don't really care about any errors with this logic i think
const handleDismissSystemMessage = (request: any) => {
  mediator
    .request('api:invoke', {
      method: 'GET',
      url: urls.lslApi + 'user/dismissMessage/' + request.messageId,
    })
    .then((result) => {
      if (result.status === 0) {
        // store.dispatch({
        //   type: SYSTEM_NAVIGATION_MESSAGE_DISMISS,
        //   data: {
        //     messageId: request.messageId,
        //   },
        // });
      }
    });
};

mediator.subscribe('user:dismissSystemMessage', handleDismissSystemMessage);
mediator.subscribe('user:getAccount', handleGetAccount);
mediator.subscribe('user:getAccountSettings', handleGetAccountSettings);
mediator.subscribe('user:getUser', handleGetUser);
mediator.subscribe('user:loggedOut', handleLoggedOut);
mediator.subscribe('user:loginSuccess', handleLoginSuccess);
mediator.subscribe('user:userLookup', handleUserLookup);
